// extracted by mini-css-extract-plugin
module.exports = {"container":"hero-video-module--container--2Xrk9","video":"hero-video-module--video--TTErC"};